import { render } from "./BaseCard.vue?vue&type=template&id=59488fd6&scoped=true"
import script from "./BaseCard.vue?vue&type=script&lang=js"
export * from "./BaseCard.vue?vue&type=script&lang=js"

import "./BaseCard.vue?vue&type=style&index=0&id=59488fd6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-59488fd6"

export default script